import { render, staticRenderFns } from "./BatchNameTable.vue?vue&type=template&id=1ec73231&scoped=true&"
import script from "./BatchNameTable.vue?vue&type=script&lang=js&"
export * from "./BatchNameTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec73231",
  null
  
)

export default component.exports